import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// A badge carries a WORD, so it uses the label step: 11px, 600, +0.07em,
// uppercase. `default` must never be the accent: magenta is navigation and
// focus, never a badge fill.
const badgeVariants = cva(
  "inline-flex items-center rounded border px-2.5 py-0.5 text-label font-semibold uppercase tracking-[0.07em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-rust-rand bg-rust-vlak text-rust-tekst",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-fout-rand bg-fout-vlak text-fout-tekst",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
